import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetOutages: IMcAppType = {
  name: "internetOutages",
  path: "/my/internet/outages",
  description: "Internet Outages",
  parameters: {
    properties: {
      accountNumber: CommonParameters.superloopAccountNumber,
    },
  },
  navFlow: NavFlow.FOCUS,
  title: "Internet outages",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "internetOutages",
    customerType: CustomerType.kraken,
  },
};
